var React = require('react');

function RequestPluginInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_2254","data-name":"Group 2254","transform":"translate(-150.225 -800.225)"},[React.createElement("rect",{"id":"Rectangle_187","data-name":"Rectangle 187","width":"52","height":"52","rx":"6","transform":"translate(150.225 800.225)","fill":"#17203c","key":0}),React.createElement("path",{"id":"Union_23","data-name":"Union 23","d":"M10.695,22.918V13.75H1.528a1.528,1.528,0,1,1,0-3.056h9.167V1.528a1.528,1.528,0,0,1,3.056,0v9.167h9.168a1.528,1.528,0,1,1,0,3.056H13.751v9.167a1.528,1.528,0,0,1-3.056,0Z","transform":"translate(164.002 813.607)","fill":"#fff","key":1})]));
}

RequestPluginInline.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52"};

module.exports = RequestPluginInline;

RequestPluginInline.default = RequestPluginInline;
